import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { Contract } from './contract.model';

export class Invoice extends BitfStrapiModel {
  number: number;
  dateCreation: Date;
  total: number;
  contract: Contract;
  nso: string;

  constructor(data: Partial<Invoice> = {}) {
    super({ data });

    if (data.contract) {
      this.contract = new Contract(data.contract);
    }
  }

  get serialised() {
    return {
      number: this.number,
      dateCreation: this.dateCreation,
      total: this.total,
      contract: this.contract?.documentId,
      nso: this.nso,
    };
  }
}
